// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

.LoginFailRow {
  --bs-table-striped-bg: red;  
  --bs-table-active-bg: red;
  --bs-table-hover-bg: red;
  --bs-table-bg: red;
}

.ActivatedRow {
  --bs-table-striped-bg: green;  
  --bs-table-active-bg: green;
  --bs-table-hover-bg: green;
  --bs-table-bg: green;
}

.DeactivatedRow {
  --bs-table-striped-bg: orange;  
  --bs-table-active-bg: orange;
  --bs-table-hover-bg: orange;
  --bs-table-bg: orange;
}

.Table {
  font-size: calc(30px);

}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;EACzB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;;AAEvB","sourcesContent":[".App {\n  text-align: center;\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n.LoginFailRow {\n  --bs-table-striped-bg: red;  \n  --bs-table-active-bg: red;\n  --bs-table-hover-bg: red;\n  --bs-table-bg: red;\n}\n\n.ActivatedRow {\n  --bs-table-striped-bg: green;  \n  --bs-table-active-bg: green;\n  --bs-table-hover-bg: green;\n  --bs-table-bg: green;\n}\n\n.DeactivatedRow {\n  --bs-table-striped-bg: orange;  \n  --bs-table-active-bg: orange;\n  --bs-table-hover-bg: orange;\n  --bs-table-bg: orange;\n}\n\n.Table {\n  font-size: calc(30px);\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
